/**
 * Dashboard list + open dashboard routes: any of these grants access.
 * - access_all_dashboards: full tenant catalog; All / My toggle in UI.
 * - access_my_dashboards: My catalog only (API forces scope=my).
 */
export const DASHBOARD_ROUTE_PERMISSIONS = [
  'access_all_dashboards',
  'access_my_dashboards',
];

/** User may see the full-tenant (All) explorer mode and the All/My switch. */
export function canAccessAllDashboardsCatalog(hasPermissionFn) {
  return hasPermissionFn('access_all_dashboards');
}

/** User may use dashboard routes / explorer at all. */
export function canAccessDashboardRoutes(hasPermissionFn) {
  return DASHBOARD_ROUTE_PERMISSIONS.some((code) => hasPermissionFn(code));
}

/** access_my_dashboards only (no all-catalog permission): forced My mode in UI/API. */
export function isMyDashboardsOnlyAccess(hasPermissionFn) {
  return (
    hasPermissionFn('access_my_dashboards') && !canAccessAllDashboardsCatalog(hasPermissionFn)
  );
}
